// Strings of the register's three payment buttons (owner's layout of 2026-10-28, rule W-16): Cash, mada / Network and
// Payment Options, and Settings › POS payment buttons. Arabic marked "new" needs review by an Arabic copy editor.
export const QUICKPAY_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    qpCash: "Cash",
    qpCard: "mada / Network",
    qpOptions: "Payment Options",
    qpCashHint: "Completes the sale at once in cash ({t}), unposted, and prints the receipt on this PC's receipt printer.",
    qpCardHint: "Completes the sale at once by card ({t}), unposted, and prints the receipt. Records the payment only: take it on the terminal first.",
    qpOptionsHint: "Every payment method you may use, with split amounts and payment on account.",
    qpSettingsLink: "POS payment buttons",
    qpWhy: "{b}: more information",
    qpProblem_not_configured: "{b} is not set up for this branch. It is set in Settings › POS payment buttons.",
    qpProblem_no_access: "{b} uses {t}, which is not among your treasuries. Ask an administrator, or use Payment Options.",
    qpProblem_treasury_kind: "{b} uses {t}, which is not of the right kind (a cash box for Cash, a bank for mada / Network).",
    qpProblem_treasury_branch: "{b} uses {t}, which belongs to another branch.",
    qpProblem_treasury_no_account: "{b} uses {t}, which has no ledger account (Settings › Treasuries).",
    qpProblem_cash_other_drawer: "Cash is set to {t}, but your shift is on another cash box. Use Payment Options, or set Cash to the shift's cash box.",
    setPosButtons: "POS payment buttons",
    qpSettingsIntro: "Choose, for each branch, the treasury that the register's Cash and mada / Network buttons complete the sale with. Nothing is chosen for you: a button left unset is shown disabled with the reason. Payment Options always offers every treasury the cashier may use.",
    qpShiftDrawer: "The cash box the shift is opened on",
    qpNotSet: "Not set (button disabled)",
    qpCommission: "commission {x} %",
    qpNoAccountTag: "no ledger account",
    qpSaved: "{b} for {x} saved.",
    qpCleared: "{b} for {x} cleared: the button is disabled there.",
    qpUpdated: "Last changed {at} by {u}",
    qpCardNote: "mada / Network records the payment method only: Delta is not connected to a card terminal.",
    fieldTreasuryKind: "Choose a cash box for Cash and a bank treasury for mada / Network.",
    fieldTreasuryBranch: "This treasury belongs to another branch.",
    fieldTreasuryNoAccount: "This treasury has no ledger account: set it in Settings › Treasuries first."
  },
  ar: {
    qpCash: "نقدًا", // new
    qpCard: "شبكة", // new
    qpOptions: "خيارات الدفع", // new
    qpCashHint: "يُتم البيع فورًا نقدًا ({t})، دون ترحيل، ويطبع الإيصال على طابعة الإيصالات في هذا الجهاز.", // new
    qpCardHint: "يُتم البيع فورًا بالبطاقة ({t})، دون ترحيل، ويطبع الإيصال. يسجّل طريقة الدفع فقط: خذ المبلغ على الجهاز أولًا.", // new
    qpOptionsHint: "كل طرق الدفع المتاحة لك، مع تقسيم المبالغ والدفع الآجل.", // new
    qpSettingsLink: "أزرار الدفع في نقطة البيع", // new
    qpWhy: "{b}: مزيد من المعلومات", // new
    qpProblem_not_configured: "{b} غير مُعدّ لهذا الفرع. يُعدّ من الإعدادات › أزرار الدفع في نقطة البيع.", // new
    qpProblem_no_access: "{b} يستخدم {t}، وهي ليست من خزائنك. اطلب ذلك من المسؤول، أو استخدم خيارات الدفع.", // new
    qpProblem_treasury_kind: "{b} يستخدم {t}، وهي ليست من النوع الصحيح (صندوق نقدي للنقد، وبنك للشبكة).", // new
    qpProblem_treasury_branch: "{b} يستخدم {t}، وهي تابعة لفرع آخر.", // new
    qpProblem_treasury_no_account: "{b} يستخدم {t}، وليس لها حساب في دليل الحسابات (الإعدادات › الخزائن).", // new
    qpProblem_cash_other_drawer: "النقد مُعدّ على {t}، لكن ورديتك على صندوق نقدي آخر. استخدم خيارات الدفع، أو اجعل النقد على صندوق الوردية.", // new
    setPosButtons: "أزرار الدفع في نقطة البيع", // new
    qpSettingsIntro: "اختر لكل فرع الخزينة التي يُتم بها زرا «نقدًا» و«شبكة» البيع في نقطة البيع. لا يُختار شيء تلقائيًا: الزر غير المُعدّ يظهر معطّلًا مع السبب. «خيارات الدفع» تعرض دائمًا كل خزينة يحق للكاشير استخدامها.", // new
    qpShiftDrawer: "الصندوق النقدي الذي فُتحت عليه الوردية", // new
    qpNotSet: "غير مُعدّ (الزر معطّل)", // new
    qpCommission: "عمولة {x} ٪", // new
    qpNoAccountTag: "بلا حساب", // new
    qpSaved: "تم حفظ {b} لفرع {x}.", // new
    qpCleared: "أُلغي إعداد {b} لفرع {x}: الزر معطّل هناك.", // new
    qpUpdated: "آخر تعديل {at} بواسطة {u}", // new
    qpCardNote: "زر الشبكة يسجّل طريقة الدفع فقط: دلتا غير متصلة بجهاز البطاقات.", // new
    fieldTreasuryKind: "اختر صندوقًا نقديًا للنقد وخزينة بنكية للشبكة.", // new
    fieldTreasuryBranch: "هذه الخزينة تابعة لفرع آخر.", // new
    fieldTreasuryNoAccount: "ليس لهذه الخزينة حساب في دليل الحسابات: أضفه من الإعدادات › الخزائن أولًا.", // new
    fieldCommissionNoAccount: "لهذه الخزينة نسبة عمولة دون حساب عمولة: أضفه من الإعدادات › الخزائن أولًا." // new
  }
};
